var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { useOutletContext } from 'react-router-dom';
export var ContentContext = React.createContext({
    contentPath: undefined,
});
export var ContentContextProvider = function (_a) {
    var path = _a.path, children = _a.children;
    var _b = (useOutletContext() || {}).parentPath, parentPath = _b === void 0 ? '' : _b;
    var contentPath = "".concat(parentPath === null || parentPath === void 0 ? void 0 : parentPath.replace(/.*\/$/g, ''), "/").concat(path);
    contentPath = contentPath !== '/' ? contentPath : '';
    return _jsx(ContentContext.Provider, __assign({ value: { contentPath: contentPath } }, { children: children }));
};
